import { lazy } from 'react';
import { melioIcon } from '@tools/ui/assets';
import type { AppRouter } from '@tools/ui/types';

export const BASE_PATH = '/melgov';

const MainView = lazy(
  () => import(/* webpackChunkName: "MelgovRoutes" */ '../pages/MainView')
);

export const melgovRoutes: AppRouter = {
  modules: [
    {
      redirectFrom: [BASE_PATH, `${BASE_PATH}/*`]
    },
    {
      name: 'Devin.AI',
      path: `${BASE_PATH}/devin`,
      component: MainView,
      exact: false,
      icon: melioIcon,
      pages: []
    }
  ]
};
